export const generateTestId = (appearance: string, selected?: boolean, disabled?: boolean): string => {
  let testId = `button-${appearance}`;

  if (selected) {
    testId += '-selected';
  }

  if (disabled) {
    testId += '-disabled';
  }

  return testId;
};

export const generateIconAriaLabel = (iconType?: string): string =>
  iconType ? iconType.replaceAll('-', ' ') : 'button icon';
